import React, {useState} from 'react';
import Select from 'react-select';
import {useQuery} from '@apollo/client';
import Query from '../../components/Query';
import Icon from '../../components/Icon';
import ClientLikesList from '../Client/LikesList';
import {isActive} from '../Client/utils';
import {QUERY_LESSON_LIST} from '../Lesson/graphql';
import {QUERY_USER} from '../Client/graphql';
import {QUERY_FORUM_LIST} from './graphql';
import ForumSave from './Save';
import ForumItem from './Item';
import {Link} from 'react-router-dom';

const STATUSES = [
  {label: 'Открытые', value: false},
  {label: 'Закрытые', value: true},
];

const ForumList = () => {
  const {user} = useQuery(QUERY_USER).data;

  const [isCreating, setCreating] = useState(false);
  const [filters, setFilters] = useState({search: '', lessons: []});
  const [showInfo, setShowInfo] = useState(!localStorage.getItem('alertedForum@quiz-client'));

  const query = useQuery(QUERY_FORUM_LIST, {
    fetchPolicy: 'cache-and-network',
    variables: {...filters, isClosed: filters.status, lessons: filters.lessons.map(x => x.id).join(',')},
  });

  const {lessonList} = useQuery(QUERY_LESSON_LIST).data || {lessonList: []};

  return (
    <div className="ForumList py-4">
      {!isActive(user) && (
        <div className="alert alert-warning p-3 mt-4 mb-4">
          <div className="row justify-content-center align-items-center">
            <div className="col-auto text-center ms-1">
              {user.client.activeTill ? 'Активация вашего аккаунта просрочена.' : ''} Для создания темы требуется
              активация.
            </div>
            <div className="col-auto">
              <Link to="/payments" className="btn btn-link p-0 ms-2">
                Активировать
              </Link>
            </div>
          </div>
        </div>
      )}
      {showInfo && (
        <div className="alert alert-info text-center">
          <div>
            Возникли вопросы при изучении, задайте их на форуме, наши знатоки будут рады вам помочь.
            <br />
            Если продвинулись в изучении, можете помочь другим{' '}
          </div>
          <button
            onClick={() => {
              setShowInfo(false);
              localStorage.setItem('alertedForum@quiz-client', true);
            }}
            type="button"
            className="btn btn-light btn-sm mt-2"
          >
            <span>Закрыть</span>
          </button>
        </div>
      )}
      <div className="row gx-lg-5 gy-5 justify-content-center">
        <div className="col-12 col-md-9 col-xl-6">
          <div className="row align-items-center justify-content-between mb-4" style={{height: 40}}>
            <div className="col-auto font-5">Список форумов</div>
            {!isCreating && (
              <div className="col-auto">
                <button disabled={!isActive(user)} onClick={() => setCreating(true)} className="btn btn-primary">
                  {!isActive(user) && <Icon name="lock" cls="me-1" />}
                  <span>Создать</span>
                </button>
              </div>
            )}
          </div>
          {!isCreating && (
            <div>
              <div className="position-relative">
                <input
                  value={filters.search}
                  onChange={e => setFilters({...filters, search: e.target.value})}
                  className="form-control mb-3"
                  placeholder="Поиск по контенту"
                  type="text"
                />
                <div className="position-absolute" style={{right: 10, top: 4}}>
                  {filters.search ? (
                    <button onClick={() => setFilters({...filters, search: ''})} className="btn btn-sm btn-light p-0">
                      <Icon name="times" color="dark" />
                    </button>
                  ) : (
                    <Icon name="search" color="lightgray" />
                  )}
                </div>
              </div>
              <div className="row gx-3">
                <div className="col-lg-6">
                  <Select
                    options={lessonList}
                    getOptionLabel={op => op.name}
                    getOptionValue={op => op.id}
                    onChange={op => setFilters({...filters, lessons: op ? [op] : []})}
                    value={filters.lessons}
                    classNamePrefix="white"
                    className="mb-4"
                    placeholder="Все темы"
                    isClearable
                  />
                </div>
                <div className="col-lg-6">
                  <Select
                    options={STATUSES}
                    onChange={op => setFilters({...filters, status: op ? op.value : undefined})}
                    value={STATUSES.find(x => x.value === filters.status)}
                    classNamePrefix="white"
                    className="mb-4"
                    placeholder="Все статусы"
                    isClearable
                  />
                </div>
              </div>
            </div>
          )}
          <div className="border rounded overflow-hidden bg-white">
            {isCreating && <ForumSave onClose={() => setCreating(false)} onSuccess={() => query.refetch()} />}
            {Query(query) || (
              <div className="list-group list-group-flush">
                {query.data.forumList.map(item => (
                  <ForumItem key={item.id} item={item} />
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="col-xl-4">
          <ClientLikesList />
        </div>
      </div>
    </div>
  );
};

export default ForumList;
